import axios, { AxiosInstance, AxiosStatic } from 'axios'
import { IUser } from 'bets.oddprovider.lib.common.ts/models'
import { WebUtils } from 'fwork-jsts-common/src'
import { IAuthenticationState } from 'fwork.react.apptemplate'
import { clearReducers, store } from '../redux/store'

const customAxios: AxiosStatic | AxiosInstance = axios.create()

customAxios.interceptors.request.use(config => {
  let authenticationStr = WebUtils.getCookie('@authenticationState')
  let authentication: IAuthenticationState<IUser> | undefined = undefined
  try {
    if (authenticationStr)
      authentication = JSON.parse(authenticationStr)
  } catch (error) {

  }

  if (!authentication?.payload?.token) {
    window.location.href = '/#/login'
    return Promise.reject()
  }

  config.headers['Authorization'] = `Bearer ${authentication?.payload?.token}`

  return config
}, error => Promise.reject(error))

customAxios.interceptors.response.use(function (response) {
  return response
}, async error => {
  if (error.response.status === 401) {
    clearReducers.forEach(action => store.dispatch(action()))
    window.location.href = '/#/login'
  }

  return Promise.reject(error)
})

export default customAxios
